module.exports = __webpack_public_path__ + "img/spain.a62a83f3.svg";